document.addEventListener('DOMContentLoaded', () => {
    function loadScripts() {
        // logic for active menu item ====================================
        const menuItems = document.querySelectorAll(".pt-menu__item"),
            currentPath = window.location.pathname;

        menuItems.forEach(item => {
            if (item.getAttribute("href") === currentPath) {
                item.classList.add("active-js");
            }
        });
        // end logic for active menu item ====================================

        // logic for dropdown ====================================
        const dropdownBtns = document.querySelectorAll(".pt-dropdown-btn"),
            dropdownContents = document.querySelectorAll(".pt-dropdown-content");

        dropdownBtns.forEach((dropdownBtn, index) => {
            let selectedLocale = dropdownBtn.textContent.trim();
            const dropdownContent = dropdownContents[index];

            function updateLocaleList() {
                const dropdownItems = dropdownContent.querySelectorAll("li");
                dropdownItems.forEach(dropdownItem => {
                    if (dropdownItem.textContent !== selectedLocale) {
                        dropdownItem.style.display = "block";
                        dropdownItem.addEventListener("click", () => {
                            setSelectedLocale(dropdownItem.textContent);
                            closeDropdown();
                        });
                    } else {
                        dropdownItem.style.display = "none";
                    }
                });
            }

            function setSelectedLocale(item) {
                selectedLocale = item;
                dropdownBtn.innerHTML = `${item}
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 12.8334L5 7.83341L6.16667 6.66675L10 10.5001L13.8333 6.66675L15 7.83341L10 12.8334Z" fill="white"/>
                </svg>
                `;
                updateLocaleList();
            }

            function closeAllDropdowns() {
                dropdownContents.forEach(content => content.style.display = 'none');
                dropdownBtns.forEach(btn => btn.classList.remove('active'));
            }

            function toggleDropdown() {
                const isOpen = dropdownContent.style.display === 'block';
                closeAllDropdowns();
                if (!isOpen) {
                    dropdownContent.style.display = 'block';
                    dropdownBtn.classList.add('active');
                    updateLocaleList();
                }
            }

            dropdownBtn.addEventListener("click", function (event) {
                event.stopPropagation();
                toggleDropdown();
            });

            document.addEventListener("click", closeAllDropdowns);

            setSelectedLocale(selectedLocale);
        });
        // end logic for dropdown ====================================

        // logic for content page (decoration element) ====================================
        const titleContent = document.querySelector('.pt-content-wrapper__title'),
            contentIndent = document.querySelector('.indent');

        if (titleContent && contentIndent) {
            contentIndent.style.height = getFullHeightWithMargin(titleContent) + "px";
        }

        function getFullHeightWithMargin(element) {
            const elementHeight = element.getBoundingClientRect().height;

            const computedStyle = window.getComputedStyle(element);
            const marginTop = parseFloat(computedStyle.marginTop);
            const marginBottom = parseFloat(computedStyle.marginBottom);

            return elementHeight + marginTop + marginBottom;
        }

        // end logic for content page (decoration element) ====================================

        // logic for options modal mobile ====================================
        const optionsCloseBtn = document.querySelector('#optionsCloseBtn'),
            optionsOpenBtn = document.querySelector('#optionsOpenBtn'),
            ptContentLeft = document.querySelector('.pt-content-left'),
            body = document.body;

        if (optionsCloseBtn && optionsOpenBtn && ptContentLeft) {
            optionsOpenBtn.addEventListener('click', () => {
                ptContentLeft.classList.add('active-js');
                body.classList.add('active-js');
            })

            optionsCloseBtn.addEventListener('click', () => {
                ptContentLeft.classList.remove('active-js');
                body.classList.remove('active-js');
            })
        }
        // end logic for options modal mobile ====================================

        // logic for categories active element ====================================
        const ptCategoriesCategory = document.querySelector('#ptCategoriesCategory');

        if (ptCategoriesCategory) {
            const ptCategoriesItem = ptCategoriesCategory.querySelectorAll('.pt-categories__item');

            ptCategoriesItem.forEach(item => {
                item.addEventListener('click', () => {
                    ptCategoriesItem.forEach(i => i.classList.remove('active-js'));

                    item.classList.add('active-js');
                });
            });
        }
        // end logic for categories active element ====================================

        // logic for video description trunc ====================================
        const videoDescription = document.getElementById("videoDescription");

        if (videoDescription) {
            const videoFullText = videoDescription.innerHTML;
            const VideoTruncatedText = videoFullText.slice(0, 200) + '... <button class="text-white" id="toggleBtnDescription">more</button>';
            let isExpanded = false;

            videoDescription.innerHTML = VideoTruncatedText;

            videoDescription.addEventListener("click", (event) => {
                if (event.target && event.target.id === "toggleBtnDescription") {
                    isExpanded = !isExpanded;

                    videoDescription.innerHTML = isExpanded
                        ? videoFullText + ' <button class="text-white" id="toggleBtnDescription">less</button>'
                        : VideoTruncatedText;
                }
            });
        }
        // end logic for video description trunc ====================================

        if (window.innerWidth <= 768) {
            const bannerImage = document.getElementById('banner-image');

            if (bannerImage) {
                bannerImage.setAttribute('loading', 'lazy');
            }
        }

        // logic for affiliate from ====================================
        const affiliateGenerateBtn = document.getElementById("generateBtn"),
            affiliateCopyLinkIcon = document.getElementById("copyLinkIcon"),
            cryptoNetwork = document.getElementById("cryptoNetwork"),
            walletAddress = document.getElementById("walletAddress"),
            affiliateLink = document.getElementById("affiliateLink"),
            networkError = document.getElementById("networkError"),
            walletError = document.getElementById("walletError"),
            affiliateNotification = document.getElementById("notification");

        function showNotification(message, success = true) {
            affiliateNotification.textContent = message;
            affiliateNotification.style.background = success ? "rgba(76, 175, 80, 0.65)" : "rgba(216, 39, 26, 0.59)";
            affiliateNotification.style.opacity = "1";
            affiliateNotification.style.visibility = "visible";
            setTimeout(() => {
                affiliateNotification.style.opacity = "0";
                affiliateNotification.style.visibility = "hidden";
            }, 3000);
        }

        affiliateGenerateBtn.addEventListener("click", function () {
            let valid = true;
            networkError.style.display = "none";
            walletError.style.display = "none";

            if (!cryptoNetwork.value) {
                networkError.style.display = "block";
                valid = false;
            }
            if (!walletAddress.value.trim()) {
                walletError.style.display = "block";
                valid = false;
            }
            if (!valid) return;

            const network = cryptoNetwork.value.toLowerCase();
            const wallet = walletAddress.value.trim();
            const trackingId = "5454389";
            const targetPath = "/app";

            const link = `https://www.porntotal.com${targetPath}?tracking_id=${trackingId}&utm_source=affiliate&target=https://www.porntotal.com${targetPath}&utm_campaign=${wallet}&utm_medium=${network}`;
            affiliateLink.value = link;
            affiliateCopyLinkIcon.style.opacity = "1";
            affiliateCopyLinkIcon.style.pointerEvents = "auto";
        });

        affiliateCopyLinkIcon.addEventListener("click", function () {
            if (!affiliateLink.value) return;
            navigator.clipboard.writeText(affiliateLink.value).then(() => {
                showNotification("Affiliate link copied to clipboard!");
            });
        });
        // end logic for affiliate from ====================================
    }

    window.addEventListener('scroll', loadScripts, {once: true});
})